import { createSlice } from "@reduxjs/toolkit";
import { IStudentTermDetail } from "../../../models/student/studentTerm";

const initialStudentTermDetails: IStudentTermDetail ={
    studentTermDetail: undefined
};

const studentTermDetailSlice = createSlice ({
    name : "studentTermDetail",
    initialState : initialStudentTermDetails,
    reducers: {
        setStudentTermDetail: (state, action: { payload: any }) => {
            state.studentTermDetail = action.payload;
        },
    },
});

export const {setStudentTermDetail} = studentTermDetailSlice.actions;

const studentTermDetailReducer = studentTermDetailSlice.reducer;

export type studentTermDetailState = ReturnType<typeof studentTermDetailReducer>;

export default studentTermDetailReducer;